import { setSelectedFuelId, setSelectedFuelSourceId, setSelectedGeneratorId, setSelectedSourceId } from "../../../redux/slices/powerSlice";
import { ALARMS, CAMERAS, CHARGERS, EVENTS, FUEL, LOGS, MAPS, POWER_GENERATION, POWER_DIAG, REMOTE, REPORTS, SOLAR, STARLINK } from "../../../utils/constants";

type NavigationOptions = {
    selectedCustomerName: string;
    selectedSite: string;
    item: string;
    generatorList: any[];
    generatorListForMQTT: any[];
    fuelGenList: any[];
    loadingPower: boolean;
    dispatch: any;
    navigate: (path: string) => void;
};

const getNavigationPathForItem = ({
    selectedCustomerName,
    selectedSite,
    item,
    generatorList,
    generatorListForMQTT,
    fuelGenList,
    loadingPower,
    dispatch,
    navigate
}: NavigationOptions): void => {
    const validItems = [SOLAR, CHARGERS, REPORTS, CAMERAS, ALARMS, MAPS, STARLINK, REMOTE, EVENTS, LOGS];

    if (validItems.includes(item)) {
        navigate(`/${selectedCustomerName}/${selectedSite}/${item}`);
        return;
    }

    if (item === POWER_GENERATION) {
        if (generatorList?.length > 0 && !loadingPower) {
            navigate(`/${selectedCustomerName}/${selectedSite}/${POWER_GENERATION}/${generatorList[0].equipment_id}`);
        } else if (generatorList?.length === 0 && !loadingPower) {
            dispatch(setSelectedGeneratorId(null));
            dispatch(setSelectedSourceId(''));
            navigate(`/${selectedCustomerName}/${selectedSite}/${POWER_GENERATION}`);
        } else {
            navigate(item); // Fallback
        }
        return;
    }

    if (item === POWER_DIAG) {
        if (generatorListForMQTT?.length > 0 && !loadingPower) {
            navigate(`/${selectedCustomerName}/${selectedSite}/${POWER_DIAG}/${generatorListForMQTT[0].equipment_id}`);
        } else if (generatorListForMQTT?.length === 0 && !loadingPower) {
            dispatch(setSelectedGeneratorId(null));
            dispatch(setSelectedSourceId(''));
            navigate(`/${selectedCustomerName}/${selectedSite}/${POWER_DIAG}`);
        } else {
            navigate(item); // Fallback
        }
        return;
    }

    if (item === FUEL) {
        if ((fuelGenList?.length > 0 || generatorList?.length > 0) && !loadingPower) {
            const gen = fuelGenList?.length > 0 ? fuelGenList[0] : generatorList[0];
            dispatch(setSelectedFuelId(gen.equipment_id));
            dispatch(setSelectedFuelSourceId(gen.source_id));
            navigate(`/${selectedCustomerName}/${selectedSite}/${FUEL}/${gen.equipment_id}`);
        } else if (fuelGenList?.length === 0 && generatorList?.length === 0 && !loadingPower) {
            dispatch(setSelectedFuelId(null));
            dispatch(setSelectedFuelSourceId(''));
            navigate(`/${selectedCustomerName}/${selectedSite}/${FUEL}`);
        } else {
            navigate(item); // Fallback
        }
        return;
    }
};

export default getNavigationPathForItem;